import React, { Component } from 'react';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import * as types from 'constants/actionTypes';
import util from 'library/util';
import { webMenuAddCrumb, webMenuEditCrumb } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';
import { showError } from 'actions/CommonActions';
import { initializeProductGroupForm, clearDialogItemsProductGroup, formError } from 'actions/FormActions';
import { getCategories, getProducts, saveProductGroup, getProductGroupById, getPriceMatrices } from 'actions/EntityActions';
import { selectMenuForm, selectCampaignSelectedCategories } from 'selectors/entitySelector';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import ToggleInput from 'screens/components/basic/ToggleInput';
import RadioInput from 'screens/components/basic/RadioInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import Pagination from 'screens/components/basic/Pagination';
import DialogInput from 'screens/components/advanced/DialogInput';
import SelectInput from 'screens/components/basic/SelectInput';
import CheckInput from 'screens/components/basic/CheckInput';
import Grid from 'screens/components/basic/Grid';
import DialogHeader from 'screens/components/basic/DialogHeader';
import ImageUploading from './components/ImageUploading';

const productGroupSaveComponentName = "productGroup";
class ProductGroupSave extends Component {

    constructor(props) {
        super(props);

        this.state = {
            productList: [],
            categoryList: [],
            productListEdit: [],
            categoryListEdit: [],
            activePage: 1,
            itemsPerPage: 25,
            status: "",
            dialogProducts: false,
            menuId: 0,
            errorNoAddedItems: false
        };
    }

    componentWillMount() {
        const menuId = this.props.params.id;
        if (menuId) {
            this.setState({ status: "EDIT", menuId: menuId });
            this.props.getProductGroupById({
                id: menuId,
                branchId: this.props.branchId,
                compName: productGroupSaveComponentName
            });
        }
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
        this.props.getCategories();
        this.props.getPriceMatrices();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.products) {
            if (newProps.products.length > 0 && newProps.products !== this.props.products) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        productList: [...newProps.products]
                    };
                });
            }
        }

        if (newProps.productsListEdit) {
            if (newProps.productsListEdit.length > 0 && newProps.productsListEdit !== this.props.productsListEdit) {
                this.productSelected(newProps.productsListEdit);
            }
        }

        if (newProps.categoriesListEdit) {
            if (newProps.categoriesListEdit.length > 0 && newProps.categoriesListEdit !== this.props.categoriesListEdit) {
                this.setState(prevState => {
                    return {
                        ...prevState,
                        categoryListEdit: [...newProps.categoriesListEdit]
                    };
                });
            }
        }

        if (
            (newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)
        ) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure();
        }
    }

    componentWillUnmount() {
        this.props.init(this.props.name);
    }

    saveSuccess = () => {
        this.props.showProductGroupCreated(this.state.status === 'EDIT' ? LOOKUP.ecommerce.menu.messages.editedMessage : LOOKUP.ecommerce.menu.messages.createdMessage);
        this.redirectToMenu();
    }

    saveFailure = () => {
        this.props.showPatientError(LOOKUP.ecommerce.menu.messages.saveErrorMessage);
    }

    productSelected = (products) => {
        this.setState(prevState => {
            return {
                ...prevState,
                productListEdit: products
            };
        });
    }

    // function applied on Header Back Button to redirect to the Menu page (ecommerce/menu)
    redirectToMenu() {
        this.props.navigate('/ecommerce/menu');
    }

    // function to add the products to the menu
    addProductToMenu = (product) => {
        let products = this.state.productListEdit;
        products.push(product);
        this.setState(prevState => {
            return {
                ...prevState,
                productListEdit: [...products]
            };
        }, this.validateItems);
    }

    removeProduct = (product) => {
        const products = this.state.productListEdit.filter(p => p.id !== product.id);
        this.setState(prevState => {
            return {
                ...prevState,
                productListEdit: [...products]
            };
        });
    }

    addCategoriesToMenu = () => {
        const categories = this.props.categoriesList.filter(c => this.props.selectedCategoriesIds.indexOf(c.id) !== -1);
        this.setState(prevState => {
            return {
                ...prevState,
                categoryListEdit: [...categories]
            };
        }, this.validateItems);
        this.closeProductsDialog();
    }

    removeCategory = (category) => {
        const categories = this.state.categoryListEdit.filter(p => p.id !== category.id);
        this.setState(prevState => {
            return {
                ...prevState,
                categoryListEdit: [...categories]
            };
        });
    }

    // change the page on Add Products to Menu table
    changePage = e => {
        this.setState({ activePage: e }, this.searchProducts);
    }

    openProductsDialog = () => {
        this.setState({ dialogProducts: true });
    }

    closeProductsDialog = () => {
        this.setState({ dialogProducts: false });
        this.props.clearDialogItemsProductGroup();
    }

    saveMenu = () => {
        let menu = this.props.menuModel;

        const validators = [
            [`${productGroupSaveComponentName}Name`, menu => (menu.Name && menu.Name !== null && menu.Name !== ""), "Name"],
            [`${productGroupSaveComponentName}Description`, menu => (menu.Description && menu.Description !== null && menu.Description !== 0), "Description"]
        ];

        const isFormValid = util.validate(validators, menu, this.props.formError);
        const isItemsValid = this.validateItems();

        if (isItemsValid && isFormValid) {
            menu.Id = this.state.menuId;
            menu.ProductIds = this.state.productListEdit.map(item => parseInt(item.id));
            menu.ProductCategoryIds = this.state.categoryListEdit.map(item => parseInt(item.id));
            //TODO
            //VALIDATE
            this.props.saveProductGroup({
                branchId: this.props.branchId,
                productGroupViewModel: menu,
                compName: productGroupSaveComponentName
            });
        }
    }

    searchProducts = () => {
        const model = {
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            searchText: this.props.productSearchText,
            categoryId: this.props.categoryIdSearch,
            priceMatrixId: this.props.priceMatrixIdSearch,
            branchId: this.props.branchId
        };
        this.props.getProducts(model);
    }

    search = () => {
        this.setState({ activePage: 1 }, this.searchProducts);
    }

    redirectToCampaignList = () => {
        this.props.navigate('/ecommerce/menu');
    }

    validateItems = () => {
        const isValid = (this.state.productListEdit.length > 0 || (this.state.categoryListEdit.length > 0));
        this.setState(prevState => {
            return {
                ...prevState,
                errorNoAddedItems: !isValid
            };
        });
        return isValid;
    }

    render() {
        const componentName = productGroupSaveComponentName;
        const breadCrumbPage = this.state.status === 'EDIT' ? webMenuEditCrumb : webMenuAddCrumb;
        const isEditPage = this.state.status === 'EDIT';

        const productAddList = (this.props.products || []).map(item => {
            return {
                sku: item.sku,
                name: item.name,
                category: item.category,
                type: item.type,
                icons: (this.state.productListEdit || []).filter(p => p.id === item.id).length > 0
                    ? (
                        <Button name={`${componentName}${item.id}RemoveItemFromCampaign`}
                            type="IconCheckButton"
                            className="campaign_add_btn_clicked"
                            onTouchTap={() => this.removeProduct(item)}
                        />
                    )
                    : (
                        <Button name={`${componentName}${item.id}AddProductToMenu`}
                            type="IconCheckButton"
                            className="campaign_add_btn"
                            onTouchTap={() => this.addProductToMenu(item)}
                        />
                    )
            };
        });

        const myProductList = (this.state.productListEdit || []).map((item, index) => {
            return {
                name: item.name,
                category: item.category,
                type: item.type,
                icons:
                    <Button
                        key={index}
                        name={`${componentName}${item.id}RemoveProductFromMenu`}
                        type="IconRemoveButton"
                        onTouchTap={() => this.removeProduct(item)}
                    />
            };
        });

        const myCategoryList = (this.state.categoryListEdit || []).map((item, index) => {
            return {
                name: item.name,
                icons:
                    <Button
                        key={index}
                        name={`${componentName}${item.id}RemoveCategoryFromMenu`}
                        type="IconRemoveButton"
                        onTouchTap={() => this.removeCategory(item)}
                    />
            };
        });

        let categories = (this.props.categoriesList || []).map(c => ({
            text: c.name,
            value: c.id.toString()
        })
        );

        let priceMatrices = (this.props.priceMatrices || []).map(p => ({
            text: p.name,
            value: p.id.toString()
        })
        );

        return (
            <Grid headerContent={breadCrumbPage}>
                <CardSimple title={this.state.status === 'EDIT' ? LOOKUP.ecommerce.menu.menuEdit.title : LOOKUP.ecommerce.menu.menuSave.title} className="paddingForMobileDevices mt-2 mb-2">
                    <div className="row">
                        <div className="col-lg-6">
                            {isEditPage ?
                                (
                                    <TextInput
                                        name={productGroupSaveComponentName + "Name"}
                                        label={LOOKUP.ecommerce.menu.menuSave.name}
                                        floatingLabelText={LOOKUP.ecommerce.menu.menuSave.name}
                                        fullWidth={true}
                                        maxLength={50}
                                        required
                                        disabled={true}
                                    />
                                ) :
                                (
                                    <SelectInput
                                        name={productGroupSaveComponentName + "Name"}
                                        label={LOOKUP.ecommerce.menu.menuSave.name}
                                        floatingLabelText={LOOKUP.ecommerce.menu.menuSave.name}
                                        options={LOOKUP.ecommerce.menu.menuSave.suggestedProductGroup}
                                        fullWidth={true}
                                    />
                                )
                            }

                        </div>
                        <div className="col-lg-6">
                            <TextInput
                                name={productGroupSaveComponentName + "Description"}
                                label={LOOKUP.ecommerce.menu.menuSave.description}
                                floatingLabelText={LOOKUP.ecommerce.menu.menuSave.description}
                                fullWidth={true}
                                required
                            />
                        </div>
                        <div className="col-xs-12 col-lg-4">
                            <ToggleInput name={componentName + "Status"} label={LOOKUP.ecommerce.menu.menuSave.status} className="btnToggleLabel" />
                        </div>
                    </div> {/* .row */}
                    <hr />
                    <div className="row-flex justify-content-end">
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3  justify-content-end d-flex pe-2">
                        <ImageUploading/>

                            </div>
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <Button
                                type="FloatButton"
                                label="Add Items To Menu"
                                fullWidth={true}
                                className="bg-light-green btnNewBrandPOS"
                                onTouchTap={() => this.openProductsDialog()}
                            />
                            {
                                this.state.errorNoAddedItems ? (
                                    <p className="danger">Is necessary to add at least one item to the product group</p>
                                ) : null
                            }
                        </div>
                       
                    </div>
                </CardSimple>

                {/* MODAL DIALOG */}
                <DialogInput
                    title={<DialogHeader text="Add To Menu" classicClass="posDialogClassic" />}
                    modal={true}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '980' }}
                    actions={(
                        <Button
                            name="buttonClose"
                            label="Close"
                            primary={false}
                            className="btnCleanSearch"
                            onTouchTap={() => this.closeProductsDialog()} />
                    )}
                    contentStyle={{ width: '95%', maxWidth: 'none' }}
                    open={this.state.dialogProducts}>
                    <div>
                        <h5 className="mt-2 purpleText">Add {this.props.addToMenuType == 1 ? 'Categories' : 'Products'} to Menu</h5>
                        <RadioInput
                            groupName={`AddToMenuType`}
                            className="pos_refund_radio rdBtnLabels"
                            options={[{ text: `Add by Category`, value: '1' }, { text: "Add by Product", value: '2' }]}
                            fullWidth={true}
                        />
                        <hr />
                        {this.props.addToMenuType == 1
                            ?
                            (
                                <div className="row">
                                    {
                                        this.props.categoriesList.map((item, index) => {
                                            return (
                                                <div className="col-lg-6" key={index}>
                                                    <CheckInput
                                                        name={componentName + "ProductCategory-" + item.id}
                                                        text={item.name}
                                                        value={item.id}
                                                        className="selectCampaignItems"
                                                    />
                                                </div>
                                            );
                                        })
                                    }
                                    <div className="col-lg-12">
                                        <Button
                                            className="pull-right"
                                            name="buttonAddItem"
                                            label="Add to Menu"
                                            primary={true}
                                            onTouchTap={() => this.addCategoriesToMenu()}
                                        />
                                    </div>
                                </div>
                            )
                            : null
                        }
                        {
                            this.props.addToMenuType == 2 ?
                                (
                                    <div>
                                        <div className="row mb-2">
                                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 input_no_padding">
                                                <TextInput
                                                    name={componentName + "ProductSearchText"}
                                                    fullWidth={true}
                                                    label={LOOKUP.campaign.filters.productName.label}
                                                    floatingLabelText={LOOKUP.campaign.filters.productName.label}
                                                    hintText={LOOKUP.campaign.filters.productName.hintText}
                                                />
                                            </div>
                                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 input_no_padding">
                                                <SelectInput name={`${componentName}CategoryIdSearch`}
                                                    label={LOOKUP.product.filters.category.label}
                                                    className="smallerPlaceholder"
                                                    floatingLabelText={LOOKUP.product.filters.category.label}
                                                    hintText={LOOKUP.product.filters.category.hintText}
                                                    options={categories}
                                                    fullWidth={true} />
                                            </div>
                                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 input_no_padding">
                                                <SelectInput name={`${componentName}PriceMatrixSearch`}
                                                    fullWidth={true}
                                                    className="smallerPlaceholder"
                                                    floatingLabelText={"Price Matrix"}
                                                    label={LOOKUP.product.priceMatrix.label}
                                                    options={priceMatrices}
                                                    hintText={LOOKUP.product.priceMatrix.hintText} />
                                            </div>
                                            <div className="col-lg-12">
                                                <Button
                                                    className="pull-right btnNewBrandPOS"
                                                    name="searchProductDialog"
                                                    label="Search"
                                                    primary={true}
                                                    onTouchTap={() => this.search()} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <GenericTable
                                                    className="table_center tableHeaderwhiteColorFont"
                                                    compName="productDialogListTable"
                                                    adjustForCheckbox={false}
                                                    displaySelectAll={false}
                                                    displayRowCheckbox={false}
                                                    enableSelectAll={false}
                                                    multiSelectable={false}
                                                    selectable={false}
                                                    columns={LOOKUP.campaign.productGroupAddedTableColumns}
                                                    rows={productAddList}
                                                    stripedRows={true}
                                                />
                                                <Pagination
                                                    length={this.props.productsLength || 0}
                                                    itemsPerPage={this.state.itemsPerPage}
                                                    activePage={this.state.activePage}
                                                    onPageChange={(e) => this.changePage(e)} />
                                            </div>
                                        </div>
                                    </div>
                                ) : null
                        }
                    </div>
                </DialogInput>

                <CardSimple title="Products added to Menu" className="paddingForMobileDevices">
                    {(this.state.productListEdit.length > 0) ?
                        <div className="row">
                            <div className="col-lg-12">
                                <label className="pb-2">Products Added: </label>
                                <GenericTable
                                    compName="productsAddedTable"
                                    className="menu_added_table"
                                    adjustForCheckbox={false}
                                    displaySelectAll={false}
                                    displayRowCheckbox={false}
                                    enableSelectAll={false}
                                    multiSelectable={false}
                                    selectable={false}
                                    columns={LOOKUP.campaign.productGroupAddedTableColumns}
                                    rows={myProductList}
                                    stripedRows={true}
                                />
                            </div>
                        </div>
                        :
                        <p>No Products added to this Menu</p>
                    }
                </CardSimple>
                <CardSimple title="Categories added to Menu" className="paddingForMobileDevices">
                    {(this.state.categoryListEdit.length > 0) ?
                        <div>
                            <p>Categories Added: </p>
                            <GenericTable
                                compName="productsAddedTable"
                                className="menu_added_table tableHeaderwhiteColorFont mt-1"
                                adjustForCheckbox={false}
                                displaySelectAll={false}
                                displayRowCheckbox={false}
                                enableSelectAll={false}
                                multiSelectable={false}
                                selectable={false}
                                columns={LOOKUP.campaign.categoryAddedTableColumns}
                                rows={myCategoryList}
                                stripedRows={true}
                            />
                        </div>
                        :
                        <p className='blue-text'>No Categories added to this Menu</p>
                    }
                </CardSimple>
                <div className="row marginRightMobile">
                    <div className="col-lg-12">
                        <Button
                            name="buttonSave"
                            className="pull-right btnNewBrandPOS"
                            label={LOOKUP.campaign.controls.saveButon}
                            primary={true}
                            onTouchTap={() => this.saveMenu()}
                        />
                        <Button
                            type="CancelButton"
                            name="buttonCancel"
                            className="pull-right btn-space btnCancelOperation"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.redirectToMenu()}
                        />
                    </div>
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        categoriesList: state.entity.categoriesList || [],
        priceMatrices: state.entity.priceMatricesList,
        products: state.entity.productList,
        addToMenuType: state.form.AddToMenuType,
        productsLength: state.entity.productListLength,
        branchId: state.common.branchId,
        webBranchId: state.common.webBranchId,
        saveSuccess: state.form.productGroupSaveSuccess,
        saveError: state.form.productGroupSaveSuccessSaveError,
        productsListEdit: state.form.productGroupProducts,
        categoriesListEdit: state.form.productGroupProductCategories,
        productGroupName: state.form[`${productGroupSaveComponentName}Name`],
        dialogSearchProductType: state.form[`${productGroupSaveComponentName}DialogSearchProductType`],
        productSearchText: state.form.productGroupProductSearchText,
        categoryIdSearch: state.form.productGroupCategoryIdSearch ? parseInt(state.form.productGroupCategoryIdSearch) : null,
        priceMatrixIdSearch: state.form.productGroupPriceMatrixSearch ? parseInt(state.form.productGroupPriceMatrixSearch) : null,
        menuModel: selectMenuForm(state, productGroupSaveComponentName),
        selectedCategoriesIds: selectCampaignSelectedCategories(state.form, productGroupSaveComponentName),
        isMedical: state.common.applicationSettings.isMedical
    };
};

function mapDispatchToProps(dispatch) {
    return {
        getCategories: () => dispatch(getCategories(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
        getProducts: (model) => dispatch(getProducts(model)),
        saveProductGroup: (model) => dispatch(saveProductGroup(model)),
        getProductGroupById: (model) => dispatch(getProductGroupById(model)),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        showPatientError: (message) => dispatch({ type: types.DIALOG_ALERT_OPEN, message: message }),
        showProductGroupCreated: (message) => dispatch({ type: types.SNACKBAR_SHOW_MESSAGE, message: message }),
        init: () => dispatch(initializeProductGroupForm(productGroupSaveComponentName)),
        clearDialogItemsProductGroup: () => dispatch(clearDialogItemsProductGroup(productGroupSaveComponentName)),
        formError: (name, error) => dispatch(formError(name, error)),
        showError: (message) => dispatch(showError(message))
    };
}


export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ProductGroupSave));